import React, {useEffect, useState} from "react";
import './ReviewPlanDetails.css'
import Header from "../../../components/header/Header";
import Indicator from "../../common/components/Indicator";
import {Button, Form, message} from "antd";
import ModalContent from "../../../constant/ModalContent";
import {useNavigate} from "react-router-dom";

export default function ReviewPlanDetails() {


    const [isLoading, setIsLoading] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [data,setData] = useState()
    const [watchNo,setWatchNo] = useState()
    const storedJsonString = localStorage.getItem('selectedPackage')

    const sessionId = localStorage.getItem('sessionId')



    useEffect(()=>{

        if (storedJsonString){
            const storedObject = JSON.parse(storedJsonString);

            setData(storedObject)

            localStorage.setItem("watchNo", '0771997937')

            const watchNumber = localStorage.getItem('watchNo')

            setWatchNo(watchNumber)
        }

    },[storedJsonString])


    useEffect(()=>{
        if (!sessionId){
            // Redirect to NotFoundPage if any data is null
            navigate('/not-found-page');
        }
    },[])


    const handleSubmit = async (values) => {
        setIsLoading(true);

        try {

            if (watchNo && data){
                setIsLoading(false);
                navigate("/activate-watch");
            }

        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }
    }


    return (
        <div>
            <div style={{backgroundColor: "#E6E6E6", width: "100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator/>}


            {data && watchNo &&
                (
                    <Form
                        className="form"
                        name="form"
                        onFinish={handleSubmit}
                    >
                        <h1 className="para-title">
                            Review Plan Details
                        </h1>

                        <div className='element'>
                            <div className='element-name'>
                                PLAN
                            </div>
                            <div className='element-value'>
                                {data.name}
                            </div>
                        </div>

                        <div className='element'>
                            <div className='element-name'>
                                YOUR WATCH'S NUMBER
                            </div>
                            <div className='element-value'>
                                {watchNo}
                            </div>
                        </div>

                        <div className='element'>
                            <div className='element-name'>
                                PRICE
                            </div>
                            <div className='element-value'>
                                {data.pricingModel.amount} {data.pricingModel.uom} {data.pricingModel.billCycle}.
                            </div>
                        </div>


                        <Form.Item>
                            <Button
                                className="mainButton agreeButton"
                                type="primary"
                                htmlType="submit"
                                shape={"round"}
                                style={{backgroundColor: "#f13434",marginRight: 10}}
                                // disabled={isLoading}
                            >
                                Add monthly plan
                            </Button>
                            <Button
                                className="mainButton rejectButton"
                                type="primary"
                                htmlType="submit"
                                shape={"round"}
                                style={{color: "#f13434",border: '1px solid #f13434',backgroundColor: 'white'}}
                                disabled={isLoading}
                                onClick={() => navigate('/service-agreement')}
                            >
                                Go back
                            </Button>
                        </Form.Item>
                    </Form>
                )
            }

        </div>
    );
}